function toStringOrEmpty(value: unknown): string {
	return typeof value === "string" ? value : "";
}

function isNonEmpty(value: unknown): boolean {
	if (typeof value !== "string") {
		return false;
	}
	return value.trim().length > 0;
}

export function buildFullName(firstName: unknown, lastName: unknown): string {
	const first = toStringOrEmpty(firstName).trim();
	const last = toStringOrEmpty(lastName).trim();

	const parts: string[] = [];
	if (first.length > 0) {
		parts.push(first);
	}
	if (last.length > 0) {
		parts.push(last);
	}

	return parts.join(" ");
}

export function computeEffectiveDisplayName(
	firstName: unknown,
	lastName: unknown,
	displayNameRaw: unknown,
): string {
	const display = toStringOrEmpty(displayNameRaw).trim();
	if (display.length > 0) {
		return display;
	}

	const fullName = buildFullName(firstName, lastName).trim();
	if (fullName.length > 0) {
		return fullName;
	}

	return "";
}

export function computePreferredName(
	firstName: unknown,
	lastName: unknown,
	displayNameRaw: unknown,
	emailRaw: unknown,
): string {
	const fullName = buildFullName(firstName, lastName).trim();
	if (fullName.length > 0) {
		return fullName;
	}

	const display = toStringOrEmpty(displayNameRaw).trim();
	if (display.length > 0) {
		return display;
	}

	const email = toStringOrEmpty(emailRaw).trim();
	return email;
}

export function hasAnyName(firstName: unknown, lastName: unknown): boolean {
	return isNonEmpty(firstName) || isNonEmpty(lastName);
}
